<template>
    <b-container fluid class="footer">
        <div class="navigation mx-auto">
            <b-row>
                <b-col v-for="(nav, idx) in navs" :key="idx" cols="6" md="3">
                    <div class="navs">
                        <p class="main-nav">{{ nav.name }}</p>
                        <hr />
                        <p
                            v-for="(subNav, subIdx) in nav.sub_navs"
                            :key="subIdx"
                        >
                            {{ subNav.name }}
                        </p>
                    </div>
                </b-col>
            </b-row>
        </div>
        <div class="right">
            <div>
                <p class="txt">
                    深圳市安博腾生物科技有限公司版权所有
                    <br />
                    <a href="http://beian.miit.gov.cn">粤ICP备19147210号</a>
                </p>
            </div>
        </div>
    </b-container>
</template>

<script>
import navs from "@/config/footer";
export default {
    data() {
        return {
            navs
        };
    }
};
</script>

<style lang="less">
@import "./index.less";
</style>
